var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about"}},[_c('p',[_vm._v(_vm._s(_vm.$t("about_intro")))]),_c('p',[_vm._v(_vm._s(_vm.$t("about_date")))]),_c('p',[_vm._v(_vm._s(_vm.$t("about_location_1"))),_c('br'),_vm._v(_vm._s(_vm.$t("about_location_2")))])])}
var staticRenderFns = []

export { render, staticRenderFns }